import { MAP_AUTH_FAILED_CLASS } from "../utilities/constants";
const regex = require("../utilities/regex");

/**
 * @function
 * @desctiption - Appends the error message to the element
 * @param {Element} element - Error message element
 * @param {String} errorType - Error message
 */
const appendError = (element, errorType) => {
    const $errorMsgArea = $(".address-form-error-postal-code");
    const $this = $(element);
    const $errorMsgInput = $(".ct-address-form--zipcode-input");

    if ($this.length) {
        const error = $this.attr(errorType);
        const msg = error ? error : errorType;

        $errorMsgArea.empty().html(msg).removeClass("d-none");
        $errorMsgInput.empty().addClass("is-invalid");
        setTimeout(() => $errorMsgInput.empty().removeClass("is-invalid"), 3000);
        $("#coverage-postal-code").focus();
    }
};

/**
 * @function getPostalCodeFromLocation
 * @description - Retrieves postal code of customer current position
 */
const getPostalCodeFromLocation = () => {
    let googleMaps = require("../components/googleMap");
    googleMaps.mapInit();
    let customerCoordinates = {};
    const zipCodeInput = document.getElementById("zipCode");

    $(document).on("click", ".postal-code-get-coordinates-address-form", () => {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(position => {
                customerCoordinates.latitude = position.coords.latitude;
                customerCoordinates.longitude = position.coords.longitude;

                let google = window.google;
                let geocoder = new google.maps.Geocoder;
                let latlng = {lat: parseFloat(customerCoordinates.latitude), lng: parseFloat(customerCoordinates.longitude)};

                if ($(`.${MAP_AUTH_FAILED_CLASS}`).length) {
                    appendError(".address-form-error-postal-code", "data-error-auth-failed");
                    return;
                }

                geocoder.geocode({"location": latlng}, (results, status) => {
                    if (status === "OK") {
                        if (results.length > 0) {
                            let postalDetected = false;
                            for (let i = 0; i < results.length; i++) {
                                let result = results[i];

                                if (result.types.indexOf("postal_code") !== -1) {
                                    let postalCode = result.address_components[0].long_name;
                                    if (postalCode && postalCode.length == 4 && regex.values.digits.test(postalCode)) {
                                        postalCode = postalCode.padEnd(8, "-000");
                                    }
                                    postalDetected = true;
                                    $("#zipCode").val(postalCode).addClass("filled");

                                    // check validity for zip code input
                                    if (zipCodeInput.checkValidity) {
                                        zipCodeInput.checkValidity();
                                    }
                                    break;
                                }
                            }
                            if (!postalDetected) {
                                appendError(".address-form-error-postal-code", "data-error-general");
                            }
                        } else {
                            appendError(".address-form-error-postal-code", "data-error-general");
                        }
                    } else {
                        appendError(".address-form-error-postal-code", "data-error-general");
                    }
                });
            }, () => appendError(".address-form-error-postal-code", "data-error-allowgeo"));
        } else {
            appendError(".address-form-error-postal-code", "data-error-apigeo");
        }
    });
};

const removeAddressModalEvents = () => {
    const deleteModalContent = document.querySelector(".ct-address-form--delete-modal-confirmation");
    const unsuccessfulRemovalContent = document.querySelector(".ct-address-form--unsuccessful-removal");
    const $removeAddressModal = $("#remove-address-modal");
    const deleteBillingModalContent = document.querySelector(".ct-address-form--billing-removal");
    const isBillingAddress = document.querySelector(".ct-address-form--remove-address").getAttribute("data-is-billing");

    // update modal content for Billing address
    if (isBillingAddress == "true") {
        deleteModalContent.classList.add("d-none");
        deleteBillingModalContent.classList.remove("d-none");
    }

    $removeAddressModal.off("shown.bs.modal").on("shown.bs.modal", () => {
        const deleteAddressURL = document.querySelector(".ct-address-form--remove-address").getAttribute("href");

        document.querySelector(".js-remove-address").setAttribute("href", deleteAddressURL);

        //GTM logic - Start
        document.dispatchEvent(new CustomEvent("dataLayer.messagesEvents", {
            detail: {
                "success": true,
                "messageContent": $(deleteModalContent).find(".ct-address-form--delete-modal-msg").text(),
            }
        }));
        //GTM logic - End
    });

    $removeAddressModal.off("hidden.bs.modal").on("hidden.bs.modal", () => {
        if (isBillingAddress == "false") {
            deleteModalContent.classList.remove("d-none");
            unsuccessfulRemovalContent.classList.add("d-none");
        }
    });

    const removeAddressModalBtn = document.querySelector(".js-remove-address");

    if (removeAddressModalBtn) {
        $(removeAddressModalBtn).off("click");
        removeAddressModalBtn.addEventListener("click", e => {
            e.preventDefault();
            const currentElement = e.currentTarget;
            const deleteAddressURLModal = currentElement.getAttribute("href");

            $.spinner().start();

            $.ajax({
                url: deleteAddressURLModal,
                type: "get",
                dataType: "json",
                success: data => {
                    if (data.success) {
                        window.location.href = data.redirectUrl;
                    } else {
                        deleteModalContent.classList.add("d-none");
                        unsuccessfulRemovalContent.classList.remove("d-none");
                        if (data.message) {
                            $(".ct-address-form--delete-modal-msg").html(data.message);
                            //GTM logic - Start
                            document.dispatchEvent(new CustomEvent("dataLayer.messagesEvents", {
                                detail: {
                                    "success": false,
                                    "messageContent": data.message,
                                }
                            }));
                            //GTM logic - End
                        }
                    }

                    $.spinner().stop();
                }
            });
        });
    }
};

export { getPostalCodeFromLocation, removeAddressModalEvents };
